<div class="auth-outer h-100 privacy-outer overflow-hidden d-flex flex-column" appSpin [spinnerConfig]="spinnerConfig()">
  <div class="privacy-container d-flex flex-column gap-32">
    <div class="page-title-block p-0 bg-transparent gap-8 flex-column align-items-start">
      <h1 class="h3">Privacy & Security</h1>
      <h4 class="title text-gray-6 mt-2">Two-Factor Authentication</h4>
      <p>Two-Factor Authentication for your account is an extra layer of security to your login. It helps you protect
        your
        account from fraud and theft</p>
    </div>

    <div class="toast-container w-100 position-static" *ngIf="(showWarning | async)">
      <div class="ngx-toastr toast-warning w-100">
        <h6 class="title">Activate your Two-Factor Authentication to access the platform</h6>
        <p>Your super admin has enabled Two-Factor Authentication access in privacy and security. It is mandatory for
          all users to activate the authentication.</p>
      </div>
    </div>


  </div>

  <div class="d-flex justify-content-between p-4 pt-0 overflow-hidden">
   
    <div class="d-flex flex-column gap-22 w-100 pt-4 flex-1 overflow-auto pe-2">

      <div class="card">
        <mat-expansion-panel>
          <mat-expansion-panel-header class="card-header gap-12" style="pointer-events: initial;">
            <mat-panel-title>
              <span class="d-flex align-items-center gap-12"><i class="fa-regular fa-user-shield fs-5 text-primary-dark-new"></i><h5 class="title">2-FA for your personal account</h5></span>
              
            </mat-panel-title>
            <mat-panel-description class="m-0 flex-grow-0">
              <mat-slide-toggle (change)="changeToggleStatus($event.checked)" [disabled]="mfaStatus.isToggleDisable"
                [checked]="mfaStatus.isToggleStatus" [(ngModel)]="mfaStatus.isToggleStatus"></mat-slide-toggle>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <ng-container *ngIf="mfaStatus.isToggleStatus">
              <div class="card-body">
                <ng-container *ngIf="!mfaStatus.isAuthEnabled">
                  <h5 class="mb-3">Select your preferred method of Two-Factor Authentication to access your account.
                  </h5>
                  <mat-tab-group (selectedIndexChange)="changeAuthentication($event)" [(selectedIndex)]="tabIndex"
                    class="authen-tabs auto-header-height items-horizontal">
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-radio-button value="0" [checked]="tabIndex === 0">
                          <div class="auth-tab google-auth d-flex">
                            <img src="/assets/images/icons/google.svg" alt="Google">
                            <div class="d-flex">
                              <div class="cont-block text-start px-3">
                                <h6>Activate via Google Authenticator</h6>
                                <p>Where you get verification code through a mobile / tablet app to login</p>
                              </div>
                            </div>
                          </div>
                        </mat-radio-button>
                      </ng-template>
                      <ng-template matTabContent>
                        <ng-container *ngIf="!googleAuth.isActive">
                          <div class="auth-steps pt-4 d-flex flex-column gap-20 w-100">
                            <div class="auth-steps-item">
                              <div class="item-content d-flex flex-column gap-16">
                                <h6 class="title">Step 1 : Get the Application</h6>
                                <div class="item-content-body">
                                  <p>Download and install Google Authenticator app for your phone or
                                    tablet from Play store or App store</p>
                                </div>
                              </div>
                            </div>
                            <div class="auth-steps-item">
                              <div class="item-content d-flex flex-column gap-16">
                                <h6 class="title">Step 2 : Scan the QR Code</h6>
                                <div class="item-content-body d-flex flex-column gap-8">
                                  <p>
                                    Open the authentication app in your device,<br>Click on “+” button and Scan the QR
                                    Code.
                                  </p>
                                  <p><strong>Cant scan the QR code?</strong></p>
                                  <p>Enter this key to generate 6 digit verification code</p>
                                  <mat-form-field class="fixed-label label-none icon-field-after" floatLabel="always"
                                    style="width: 300px;">
                                    <mat-label>Copy Code</mat-label>
                                    <input matInput readonly [value]="googleAuth.sharedSecret">
                                    <button matSuffix mat-button class="border-start" type="button"
                                      [cdkCopyToClipboard]="googleAuth.sharedSecret">
                                      <i class="fa-regular fa-clone"></i>
                                    </button>
                                  </mat-form-field>
                                </div>
                              </div>
                              <div class="item-right-bar" *ngIf="googleAuth && googleAuth?.qrCodeString">
                                <div class="card overflow-hidden">
                                  <qrcode [qrdata]="googleAuth.qrCodeString" [allowEmptyString]="true" [width]="180"
                                    [errorCorrectionLevel]="'M'"></qrcode>
                                </div>
                              </div>
                            </div>

                            <div class="auth-steps-item">
                              <div class="item-content d-flex flex-column gap-16">
                                <h6 class="title">Step 3 : Enter Verification Code</h6>
                                <div class="item-content-body d-flex flex-column gap-8">
                                  <p>Once the QR code above is scanned, enter the 6-digit verification code generated by
                                    Google Authenticator app</p>
                                  <form [formGroup]="otpForm"
                                    class="form-group d-flex flex-row gap-20 align-items-center">
                                    <mat-form-field class="form-item fixed-label label-none" floatLabel="always"
                                      style="width: 300px;">
                                      <mat-label>Enter Code</mat-label>
                                      <input matInput formControlName="otpNumber" (input)="verifyOTP($event)"
                                        placeholder="Enter code" minlength="6" maxlength="6" max="999999"
                                        pattern="[0-9]{6}" required>
                                      <span class="error-message" *ngIf="otpForm.get('wrongOtp').value">
                                        {{mfaConstants.WRONG_OTP}}
                                      </span>
                                    </mat-form-field>
                                    <button mat-button mat-flat-button color="secondary" class="button-default"
                                      [disabled]="!isValidOtp" (click)="setupAuthentication('google')"
                                      type="button">Verify & Activate</button>
                                  </form>
                                </div>
                              </div>
                            </div>

                          </div>
                        </ng-container>
                      </ng-template>
                    </mat-tab>

                    <mat-tab isActive="true">
                      <ng-template mat-tab-label>
                        <mat-radio-button value="1" (click)="setTabIndex($event)" [checked]="tabIndex === 1">
                          <div class="auth-tab google-auth d-flex email-auth">
                            <span>
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M35.8332 30L24.7618 20M15.238 20L4.16664 30M3.33325 11.6666L16.9415 21.1924C18.0434 21.9637 18.5944 22.3494 19.1937 22.4988C19.7231 22.6308 20.2768 22.6308 20.8061 22.4988C21.4055 22.3494 21.9564 21.9637 23.0584 21.1924L36.6666 11.6666M11.3333 33.3333H28.6666C31.4668 33.3333 32.867 33.3333 33.9365 32.7883C34.8773 32.309 35.6423 31.5441 36.1216 30.6032C36.6666 29.5337 36.6666 28.1336 36.6666 25.3333V14.6666C36.6666 11.8664 36.6666 10.4662 36.1216 9.39667C35.6423 8.45586 34.8773 7.69096 33.9365 7.21159C32.867 6.66663 31.4668 6.66663 28.6666 6.66663H11.3333C8.53299 6.66663 7.13286 6.66663 6.0633 7.21159C5.12249 7.69096 4.35759 8.45586 3.87822 9.39667C3.33325 10.4662 3.33325 11.8664 3.33325 14.6666V25.3333C3.33325 28.1336 3.33325 29.5337 3.87822 30.6032C4.35759 31.5441 5.12249 32.309 6.0633 32.7883C7.13286 33.3333 8.53299 33.3333 11.3333 33.3333Z"
                                  stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </span>
                            <div class="d-flex">
                              <div class="cont-block text-start px-3">
                                <h6>Activate via Email ID</h6>
                                <p>Where you get verification code on your mail to login</p>
                              </div>
                            </div>
                          </div>
                        </mat-radio-button>
                      </ng-template>
                      <ng-template matTabContent>
                        <ng-container *ngIf="tabIndex === 1">
                          <div class="auth-steps pt-4 pb-3 d-flex flex-column gap-20">
                            <div class="auth-steps-item">
                              <div class="item-content mw-100">
                                <h6 class="title">Add Email Authentication</h6>
                                <div class="item-content-body p-0">
                                  <p>We'll send a time-sensitive authentication code to your Email when you're signing
                                    in.</p>
                                </div>
                              </div>
                            </div>

                            <div class="auth-steps-item">
                              <div class="item-content mw-100">
                                <div class="item-content-body p-0 d-flex flex-column gap-8">
                                  <form action="" class="form-group d-flex flex-row gap-20 align-items-end">
                                    <mat-form-field class="fixed-label" floatLabel="always" style="width: 300px;">
                                      <mat-label for="veriMail">Email</mat-label>
                                      <input matInput id="veriMail" type="email" placeholder="{{userDetails.username}}"
                                        required disabled>
                                      <span *ngIf="false" class="error-message">
                                        Please provide a valid email.
                                      </span>
                                    </mat-form-field>
                                    <button mat-button mat-flat-button color="primary" class="button-default"
                                      (click)="getEmailAuthentication()" [disabled]="emailOTPStatus.disableResend"
                                      [ngStyle]="{'opacity': emailOTPStatus.disableResend ? '0.5' : '1'}" type="button">
                                      {{emailOTPStatus.text}}
                                    </button>
                                    <p class="w-100" *ngIf="emailOTPStatus.disableResend && emailOTPStatus.isResend">
                                      {{mfaConstants.RESEND_TIMER}}<span class="text-primary fw-semibold ms-1">
                                        {{resendTimer}}s</span></p>
                                  </form>
                                </div>
                              </div>
                            </div>

                            <div class="auth-steps-item">
                              <div class="item-content mw-100">
                                <div class="item-content-body p-0 d-flex flex-column gap-8">
                                  <h6 class="labbel">Enter the 6-digit verification code received in your Email</h6>
                                  <form [formGroup]="otpForm"
                                    class="form-group d-flex flex-row gap-20 align-items-center">
                                    <mat-form-field class="fixed-label label-none" floatLabel="always"
                                      style="width: 300px;">
                                      <mat-label for="veriMail">Enter Code</mat-label>
                                      <input matInput formControlName="otpNumber" (input)="verifyOTP($event)"
                                        placeholder="Enter code" minlength="6" maxlength="6" max="999999"
                                        pattern="[0-9]{6}" required>
                                      <span class="error-message" *ngIf="otpForm.get('wrongOtp').value">
                                        {{mfaConstants.WRONG_OTP}}
                                      </span>
                                    </mat-form-field>
                                    <button mat-button mat-flat-button color="secondary" class="button-default"
                                      [disabled]="!isValidOtp" (click)="setupAuthentication('email')"
                                      type="button">Verify & Activate</button>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-template>
                    </mat-tab>
                  </mat-tab-group>
                </ng-container>

                <ng-container *ngIf="mfaStatus.isAuthEnabled">
                  <div class="d-flex w-100 justify-content-between align-items-center gap-20">
                    <h6 class="label">Two-Factor Authentication enabled via <strong>{{mfaStatus.showAuthName}}</strong>
                    </h6>
                    <button mat-button mat-stroked-button color="dark" class="button-default"
                      [disabled]="mfaStatus.isToggleDisable" (click)="mfaDialogBox('ResetMFA')">Reset 2 FA</button>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-template>
        </mat-expansion-panel>
      </div>




      <ng-container *ngIf="isAccessTypeSuperAdmin | async">
        <div class="card">
          <mat-expansion-panel>
            <mat-expansion-panel-header class="card-header gap-12" style="pointer-events: initial;">
              <mat-panel-title>
                <span class="d-flex align-items-center gap-12"><i class="fa-regular fa-building-shield fs-5 text-primary-dark-new"></i> <h5 class="title">2-FA for your firm users</h5></span>
              </mat-panel-title>
              <mat-panel-description class="m-0 flex-grow-0">
                <mat-slide-toggle [formControl]="isEnabled" [checked]="isEnabled.value"
                  (click)="mfaDialogBox('Enable/Disable')"></mat-slide-toggle>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- <ng-template matExpansionPanelContent>
            Some deferred content
          </ng-template> -->
          </mat-expansion-panel>
        </div>

      </ng-container>

    </div>
    <div class="privacy-right d-flex align-items-center justify-content-center bg-primary-25 flex-column pt-0">
      <img src="/assets/images/ui-uplift-icons/auth/privacy-image.svg" alt="Auth verify">
      <!-- <button mat-flat-button (click)="faDialogOpen()" color="primary">
              <span class="tbh-act-lbl">auteh-dialog</span>
  </button> -->
    </div>
  </div>


</div>


<!-- <ng-template #MFADialog>
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <ng-container *ngIf="ResetMFADialog != 0">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-primary badge-circle icon-bordered-primary" *ngIf="ResetMFADialog === 1 && isEnabled.value === true" >
                                        <i class="fa-regular fa-circle-info text-primary"></i>
          </span>
      <span class="badge badge-warning badge-circle icon-bordered-warning" *ngIf="ResetMFADialog !== 1 || (ResetMFADialog === 1 && isEnabled.value === false)">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
    </div>

    <div class="content dialog-body-content text-center gap-8">
      <h4 class="title" *ngIf="isEnabled.value && (ResetMFADialog === 1)">{{mfaConstants.ENABLE_MESSAGE}}</h4>
       <h4 class="title" *ngIf="!isEnabled.value && (ResetMFADialog === 1)">{{mfaConstants.DISABLE_MESSAGE}}</h4>
       <h4 class="title" *ngIf="ResetMFADialog === 2">{{mfaConstants.RESETMFA_MESSAGE}}</h4>
       <h4 class="title" *ngIf="ResetMFADialog === 3">{{mfaConstants.DISABLE_MFA_MESSAGE}}</h4>
       <h4 class="title" *ngIf="ResetMFADialog === 4">{{mfaConstants.ENABLE_MFA_MESSAGE}}</h4>
    </div>

    <div mat-dialog-actions class="dialog-footer button-group">
      <ng-container *ngIf="ResetMFADialog === 1">
        <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false" (click)="isEnabled.value ? isEnabled.value = false : isEnabled.value = true">Cancel</button>
        <button mat-button mat-flat-button color="primary" class="button-default" [ngClass]="[(isEnabled.value === true) ? 'mat-primary' : 'mat-error']" [mat-dialog-close]="true">Yes</button>
      </ng-container>
      <ng-container *ngIf="ResetMFADialog !== 1">
          <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false" >Cancel</button>
          <button mat-button mat-flat-button color="error" class="button-default" [ngClass]="[ResetMFADialog === 4 ? 'mat-primary' : 'mat-error']" [mat-dialog-close]="true">Yes</button>
      </ng-container>
    </div>
   </ng-container>
  </div>
</ng-template> -->
<ng-template #MFADialog>
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <ng-container *ngIf="ResetMFADialog != 0">
      <div class="dialog-header d-flex flex-column align-items-center">
        <span class="badge badge-primary badge-circle icon-bordered-primary"
          *ngIf="(ResetMFADialog === 1 && isEnabled.value === true) || ResetMFADialog === 4">
          <i class="fa-regular fa-circle-info text-primary"></i>
        </span>
        <span class="badge badge-warning badge-circle icon-bordered-warning"
          *ngIf="ResetMFADialog === 3 || (ResetMFADialog === 1 && isEnabled.value === false)">
          <i class="fa-regular fa-triangle-exclamation text-warning"></i>
        </span>
      </div>

      <div class="content dialog-body-content text-center gap-8">
        <h4 class="title" *ngIf="isEnabled.value && (ResetMFADialog === 1)">{{mfaConstants.ENABLE_MESSAGE}}</h4>
        <h4 class="title" *ngIf="!isEnabled.value && (ResetMFADialog === 1)">{{mfaConstants.DISABLE_MESSAGE}}</h4>
        <h4 class="title" *ngIf="ResetMFADialog === 2">{{mfaConstants.RESETMFA_MESSAGE}}</h4>
        <h4 class="title" *ngIf="ResetMFADialog === 3">{{mfaConstants.DISABLE_MFA_MESSAGE}}</h4>
        <h4 class="title" *ngIf="ResetMFADialog === 4">{{mfaConstants.ENABLE_MFA_MESSAGE}}</h4>
      </div>

      <div mat-dialog-actions class="dialog-footer button-group">
        <ng-container *ngIf="ResetMFADialog === 1">
          <button mat-button mat-stroked-button color="dark" class="button-default" [mat-dialog-close]="false"
            (click)="isEnabled.value ? isEnabled.value = false : isEnabled.value = true">Cancel</button>
          <!-- <button mat-button mat-flat-button color="primary" class="button-default" [ngClass]="[(isEnabled.value === true) ? 'btn btn-primary-6' : 'btn btn-danger']" [mat-dialog-close]="true">Yes</button> -->
          <button mat-button mat-flat-button color="primary" class="button-default"
            [ngClass]="[(isEnabled.value === true) ? 'mat-primary' : 'mat-error']"
            [mat-dialog-close]="true">Yes</button>
        </ng-container>
        <ng-container *ngIf="ResetMFADialog !== 1">
          <button mat-button mat-stroked-button color="dark" class="button-default"
            [mat-dialog-close]="false">Cancel</button>
          <button mat-button mat-flat-button color="primary" class="button-default"
            [ngClass]="[ResetMFADialog === 4 ? 'mat-primary' : 'mat-error']" [mat-dialog-close]="true">Yes</button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>